import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { Button } from '@/components/ui/button';
import { useTranslation } from '@dukanti/shared';
import { formatBillingDate } from '../lib/billing-formatters';

export function CancelSubscriptionDialog(props: {
  readonly open: boolean;
  readonly paidAccessUntil: string | null;
  readonly isPending: boolean;
  readonly onOpenChange: (open: boolean) => void;
  readonly onConfirm: () => void;
}): React.JSX.Element {
  const { t, lang, dir } = useTranslation();
  const date =
    formatBillingDate(props.paidAccessUntil, lang) || t('admin.billing.currentPlan.none');

  return (
    <AlertDialog open={props.open} onOpenChange={props.onOpenChange}>
      <AlertDialogContent dir={dir}>
        <AlertDialogHeader>
          <AlertDialogTitle>{t('admin.billing.dialog.cancel.title')}</AlertDialogTitle>
          <AlertDialogDescription>
            {t('admin.billing.dialog.cancel.description', { date })}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={props.isPending}>{t('common.cancel')}</AlertDialogCancel>
          <Button
            type="button"
            variant="destructive"
            disabled={props.isPending}
            onClick={props.onConfirm}
          >
            {t('admin.billing.actions.cancel')}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
